import React from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { BackdropCircular, LoginLayout } from 'components';
import SignUpForm from './SignUpForm';


const title = 'Get started with your account';
const subtitle = 'A few clicks away from creating your online store';

const SignUpPage = () => {
  const history = useHistory();
  const isLoggedIn = Cookies.get('token');
  const { signingUp } = useSelector((state) => state.user);

  if (isLoggedIn) {
    history.push('/');
  }

  return (
    <LoginLayout
      title={title}
      subtitle={subtitle}
    >
      <>
        <SignUpForm />
        <BackdropCircular loading={signingUp} />
      </>
    </LoginLayout>
  );
};

export default SignUpPage;
